import React, { Component } from 'react';
import './HomeScreenshots.scss';
import Carousel from '../../../components/Carousel'

class HomeScreenshots extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        const screenshots = this.props.screenshots.map((item, index) => {
          return (
            <div className="col-12 col-md-4">
              {item.url}
            </div>
          )
        })

        const responsive = [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]



        return (
            <div className='home-screenshots'>

              <div className="container  section_padding_100">
                <div className='text-center'>
                  <h2>{this.props.title}</h2>
                </div>
                <div className="line-shape"></div>
                <Carousel settings={{dots: true, centerPadding: '20px', centerMode: true, infinite: true, arrows: true, speed: 500, slidesToShow: 5, slidesToScroll: 1, responsive: responsive}}>
                    {this.props.screenshots.map((item, index) => {
                      return (
                        <div key={`car${index}`} >
                          <img src={item.url} alt=""/>
                        </div>
                      )
                    })}
                </Carousel>
              </div>

            </div>
        )
    }
}

export default HomeScreenshots;



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeScreenshots/index.js